

// reactstrap components
// import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = () => {
  return (
    <>
      <div className="header  pb-6 pt-2 pt-md-6" >
        
      </div>
    </>
  );
};

export default Header;
